import { clsx } from 'clsx';
import { FC } from 'react';
import { Select } from 'atoms/Select';
import { ISelect } from 'atoms/Select/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

interface IQuantitySelect extends Omit<ISelect, 'options'> {
  limit: number;
}

export const QuantitySelect: FC<IQuantitySelect> = ({
  limit,
  onChange,
  value,
  classes,
  className,
  style,
  disabled,
  hideLabel,
}) => {
  const t = useTranslations();
  const quantityOptions = Array.from(Array(limit), (_, index) => ({
    value: index + 1,
    label: index + 1,
  }));

  return (
    <Select
      value={value}
      options={quantityOptions}
      label={t('common.fields.number')}
      onChange={onChange}
      classes={{
        root: classes?.root,
        select: clsx(classes?.select, styles.select),
      }}
      className={className}
      style={style}
      disabled={disabled}
      hideLabel={hideLabel}
    />
  );
};
